//
import PropTypes from "prop-types"
import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups.js"

import {
    AlertAlertGroupFilter,
    AlertCreatorFilter,
    AlertDataTypeFilter,
    AlertDeliveryMediumFilter,
    AlertFrequencyFilter,
    AlertIsDefaultFilter,
    AlertUpdateTypeFilter,
} from "shared/search/containers/Filter/AlertFilters"

// types

const defaultPropTypes = {
    displayLabel: PropTypes.string,
    filters: PropTypes.arrayOf(PropTypes.func),
    helpText: PropTypes.string,
    uniqueFilterGroupId: PropTypes.string,
}

// filter groups
export const AlertCreatorFilterGroup = (props) => genericFilterGroup(props)
AlertCreatorFilterGroup.propTypes = defaultPropTypes
AlertCreatorFilterGroup.defaultProps = {
    filters: [...(Userdata.is_admin ? [AlertCreatorFilter] : []), AlertIsDefaultFilter],
    uniqueFilterGroupId: "alertCreatorFilterGroup",
    displayLabel: "Creator",
    helpText: "Filter by creator",
}

export const AlertDataTypeFilterGroup = (props) => genericFilterGroup(props)
AlertDataTypeFilterGroup.propTypes = defaultPropTypes
AlertDataTypeFilterGroup.defaultProps = {
    filters: [AlertDataTypeFilter],
    uniqueFilterGroupId: "alertDataTypeFilterGroup",
    displayLabel: "Data Type",
    helpText: "Filter by alert data type",
}

export const AlertDeliveryMediumFilterGroup = (props) => genericFilterGroup(props)
AlertDataTypeFilterGroup.propTypes = defaultPropTypes
AlertDataTypeFilterGroup.defaultProps = {
    filters: [AlertDeliveryMediumFilter],
    uniqueFilterGroupId: "AlertDeliveryMediumFilterGroup",
    displayLabel: "Delivery Medium",
    helpText: "Filter by alert deliery medium type",
}

export const AlertAlertGroupFilterGroup = (props) => genericFilterGroup(props)
AlertAlertGroupFilterGroup.propTypes = defaultPropTypes
AlertAlertGroupFilterGroup.defaultProps = {
    filters: [AlertAlertGroupFilter],
    uniqueFilterGroupId: "alertAlertGroupFilterGroup",
    displayLabel: "Alert Group",
    helpText: "Filter by the Alert Group that the Alert item is associated with",
}

export const AlertFrequencyFilterGroup = (props) => genericFilterGroup(props)
AlertFrequencyFilterGroup.propTypes = defaultPropTypes
AlertFrequencyFilterGroup.defaultProps = {
    filters: [AlertFrequencyFilter],
    uniqueFilterGroupId: "alertFrequencyFilterGroup",
    displayLabel: "Alert Frequency",
    helpText: "Filter by alert frequency type",
}

export const AlertUpdateTypeFilterGroup = (props) => genericFilterGroup(props)
AlertUpdateTypeFilterGroup.propTypes = defaultPropTypes
AlertUpdateTypeFilterGroup.defaultProps = {
    filters: [AlertUpdateTypeFilter],
    uniqueFilterGroupId: "alertUpdateTypeFilterGroup",
    displayLabel: "Update Type",
    helpText: "Filter by alert update type",
}
